import api from '@utils/api';
const einsteinutils = {
    getCQuotient: function () {
        const einsteinUtils = window.CQuotient;
        if (einsteinUtils && typeof einsteinUtils.getCQUserId === 'function' && typeof einsteinUtils.getCQCookieId === 'function') {
            return einsteinUtils;
        }
        return null;
    },
    processRecommendations: function (recommender, callback, anchors, onError) {
        const einsteinUtils = this.getCQuotient();
        const params = {
            userId: einsteinUtils.getCQUserId(),
            cookieId: einsteinUtils.getCQCookieId(),
            ccver: '1.01',
        };
        if (anchors) {
            params.anchors = [];
            // maximum 5 anchors to the recommender
            anchors.splice(5);
            anchors.forEach((anchor) => {
                params.anchors.push({
                    id: anchor.masterId,
                    sku: null,
                    type: 'vgroup',
                    alt_id: anchor.id,
                });
            });
        }
        if (einsteinUtils.getRecs) {
            einsteinUtils.getRecs(einsteinUtils.clientId, recommender, params, callback, onError);
        }
        else {
            einsteinUtils.widgets = einsteinUtils.widgets || []; // eslint-disable-line no-param-reassign
            einsteinUtils.widgets.push({
                recommenderName: recommender,
                parameters: params,
                callback: callback,
            });
        }
    },
    productRecommendations: function (recommender, callback, cancelToken, anchors, slot, slotuuid, onError) {
        this.processRecommendations(recommender, (einsteinResponse) => {
            const rec = einsteinResponse[recommender];
            const pids = rec.recs.map((r) => r.id);
            // TEST ONLY
            // const pids = ['G20918C00033829H8999', 'G20918A0001084556455', '569100002A01PR001000100F', 'G10911A109005327977600', '569100001A05PR001000', 'H209Z1A00002M2904999'];
            if (pids.length) {
                api.getProductTiles(pids, cancelToken).then(async (data) => {
                    if (data) {
                        let title;
                        if (slotuuid) {
                            title = await api.getSlotContent(slotuuid, pids);
                        }
                        callback({
                            displayMessage: title || rec.displayMessage,
                            recoUUID: rec.recoUUID,
                            products: data,
                        });
                        data.forEach((product) => this.trackProductRecommended(product.id, product.masterId, recommender, slot));
                    }
                });
            }
            else {
                callback({
                    displayMessage: '',
                    recoUUID: rec.recoUUID,
                    products: [],
                });
            }
        }, anchors, onError);
    },
    productRecommendationsFromSlot: function (slot, recommenderCallback, callback, cancelToken, product, productList, onError) {
        api.getSlotConfig(slot, cancelToken).then((data) => {
            if (data) {
                // renders a slot which is supposed to be configured with a recommender and extract the recommender name from the script contained in the returned slot html
                const recommendermatch = new RegExp("recommender = '\\[\\[&quot;(.*)&quot;]]'").exec(data.data);
                if (recommendermatch && recommendermatch.length > 1) {
                    const recommender = recommendermatch[1];
                    const slotConfigurationUUIDMatch = new RegExp("slotConfigurationUUID = '(.*)'").exec(data.data);
                    const slotuuid = slotConfigurationUUIDMatch && slotConfigurationUUIDMatch.length > 1 ? slotConfigurationUUIDMatch[1] : null;
                    recommenderCallback && recommenderCallback(recommender);
                    let anchors = [];
                    if (product) {
                        anchors.push({ masterId: product.masterId, id: product.id });
                    }
                    if (productList) {
                        productList.forEach((item) => {
                            anchors.push({ masterId: item.masterId, id: item.masterId + item.analyticsAttributes.variant });
                        });
                    }
                    this.productRecommendations(recommender, callback, cancelToken, anchors, slot, slotuuid, onError);
                }
                else {
                    console.warn('no recommender found in slot response');
                    recommenderCallback && recommenderCallback(null);
                }
            }
        }, (test) => console.error(test));
    },
    trackProductDetail: function (pid, masterid) {
        window.devmode && console.info(`Tracking product detail for ${pid}`);
        try {
            window.dw.ac.capture({ id: pid, type: window.dw.ac.EV_PRD_DETAIL });
        }
        catch (e) {
            console.error(e);
        }
        const CQuotient = this.getCQuotient();
        CQuotient.trackViewProduct({
            realm: CQuotient.realm,
            siteId: CQuotient.siteId,
            instanceType: CQuotient.instanceType,
            product: {
                id: masterid,
                sku: '',
                type: 'vgroup',
                alt_id: pid,
            },
        });
        return true;
    },
    trackProductRecommended: function (pid, masterid, recommender, slot) {
        // window.devmode && console.info(`Tracking recommendation for ${pid}`);
        try {
            window.dw.ac.capture({ id: pid, type: window.dw.ac.EV_PRD_RECOMMENDATION });
        }
        catch (e) {
            console.error(e);
        }
        const CQuotient = this.getCQuotient();
        let cq_params = {};
        cq_params.cookieId = CQuotient.getCQCookieId();
        cq_params.userId = CQuotient.getCQUserId();
        cq_params.emailId = CQuotient.getCQHashedEmail();
        cq_params.loginId = CQuotient.getCQHashedLogin();
        cq_params.accumulate = true;
        cq_params.products = [
            {
                id: masterid,
                sku: '',
                type: 'vgroup',
                alt_id: pid,
            },
        ];
        cq_params.recommenderName = recommender;
        cq_params.realm = CQuotient.realm;
        cq_params.siteId = CQuotient.siteId;
        cq_params.instanceType = CQuotient.instanceType;
        cq_params.locale = CQuotient.locale;
        cq_params.slotId = slot;
        cq_params.slotConfigId = slot;
        cq_params.slotConfigTemplate = '';
        if (CQuotient.sendActivity) {
            CQuotient.sendActivity(CQuotient.clientId, 'viewReco', cq_params);
        }
        else {
            CQuotient.activities.push({ activityType: 'viewReco', parameters: cq_params });
        }
        return true;
    },
    trackProductInCategory: function (pid, category, sortingrule) {
        // window.devmode && console.info(`Tracking search hit for ${pid}`);
        try {
            window.dw.ac.capture({ id: pid, type: window.dw.ac.EV_PRD_SEARCHHIT });
        }
        catch (e) {
            console.error(e);
        }
        const CQuotient = this.getCQuotient();
        let cq_params = {};
        cq_params.cookieId = CQuotient.getCQCookieId();
        cq_params.userId = CQuotient.getCQUserId();
        cq_params.emailId = CQuotient.getCQHashedEmail();
        cq_params.loginId = CQuotient.getCQHashedLogin();
        cq_params.accumulate = true;
        cq_params.products = [
            {
                id: pid,
                sku: '',
            },
        ];
        cq_params.categoryId = category === null || category === void 0 ? void 0 : category.id;
        cq_params.refinements = JSON.stringify([{ name: 'Category', value: category === null || category === void 0 ? void 0 : category.id }]);
        cq_params.personalized = 'true';
        cq_params.sortingRule = '';
        cq_params.imageUUID = '__UNDEFINED__';
        cq_params.realm = CQuotient.realm;
        cq_params.siteId = CQuotient.siteId;
        cq_params.instanceType = CQuotient.instanceType;
        cq_params.queryLocale = window.locale;
        cq_params.locale = CQuotient.locale;
        if (CQuotient.sendActivity) {
            CQuotient.sendActivity(CQuotient.clientId, 'viewCategory', cq_params);
        }
        else {
            CQuotient.activities.push({
                activityType: 'viewCategory',
                parameters: cq_params,
            });
        }
        return true;
    },
    trackProductInSearch: function (pid, searchtext, sortingrule) {
        // window.devmode && console.info(`Tracking search hit for ${pid}`);
        try {
            window.dw.ac.capture({ id: pid, type: window.dw.ac.EV_PRD_SEARCHHIT });
        }
        catch (e) {
            console.error(e);
        }
        const CQuotient = this.getCQuotient();
        let cq_params = {};
        cq_params.cookieId = CQuotient.getCQCookieId();
        cq_params.userId = CQuotient.getCQUserId();
        cq_params.emailId = CQuotient.getCQHashedEmail();
        cq_params.loginId = CQuotient.getCQHashedLogin();
        cq_params.accumulate = true;
        cq_params.searchText = searchtext;
        cq_params.products = [
            {
                id: pid,
                sku: '',
                textRelevance: '0.92006695',
            },
        ];
        cq_params.showProducts = 'true';
        cq_params.personalized = 'true';
        cq_params.refinements = '[]';
        cq_params.sortingRule = sortingrule;
        cq_params.imageUUID = '__UNDEFINED__';
        cq_params.realm = CQuotient.realm;
        cq_params.siteId = CQuotient.siteId;
        cq_params.instanceType = CQuotient.instanceType;
        cq_params.queryLocale = window.locale;
        cq_params.locale = CQuotient.locale;
        if (CQuotient.sendActivity) {
            CQuotient.sendActivity(CQuotient.clientId, 'viewSearch', cq_params);
        }
        else {
            CQuotient.activities.push({
                activityType: 'viewSearch',
                parameters: cq_params,
            });
        }
        if (window.dw.ac) {
            let search_params = {};
            search_params.q = searchtext;
            search_params.suggestedSearchText = '';
            search_params.persd = 'true';
            search_params.refs = '[]';
            search_params.sort = sortingrule;
            search_params.imageUUID = '';
            search_params.searchID = 'b5eac80b-16a3-444d-baff-e4d269f79837';
            search_params.locale = window.locale;
            search_params.queryLocale = window.locale;
            search_params.showProducts = 'true';
            window.dw.ac.applyContext({ searchData: search_params });
            if (typeof window.dw.ac._scheduleDataSubmission === 'function') {
                window.dw.ac._scheduleDataSubmission();
            }
        }
        return true;
    },
    trackProductSet: function (pid) {
        window.devmode && console.info(`Tracking product set for ${pid}`);
        try {
            window.dw.ac.capture({ id: pid, type: window.dw.ac.EV_PRD_SETPRODUCT });
        }
        catch (e) {
            console.error(e);
        }
        return true;
    },
    categoryContext: function (cgid) {
        window.devmode && console.info(`Tracking context set to ${cgid}`);
        try {
            window.dw.ac.applyContext({ category: cgid });
        }
        catch (e) {
            console.error(e);
        }
        return true;
    },
    emptyContext: function () {
        window.devmode && console.info(`Tracking context reset`);
        try {
            window.dw.ac.applyContext({});
        }
        catch (e) {
            console.error(e);
        }
        return true;
    },
};
export default einsteinutils;
